import { render, staticRenderFns } from "./orderSummary.vue?vue&type=template&id=2553887b&scoped=true&lang=pug"
import script from "./orderSummary.vue?vue&type=script&lang=js"
export * from "./orderSummary.vue?vue&type=script&lang=js"
import style0 from "./orderSummary.vue?vue&type=style&index=0&id=2553887b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2553887b",
  null
  
)

export default component.exports